export enum IntegrationState {
    DEFAULT = 'DEFAULT',
    ORIGINAL = 'ORIGINAL',
    DRAFT = 'DRAFT',
    SYNCED = 'SYNCED',
    PENDING = 'PENDING',
    SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT = 'SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT',
    SIGNIFICANT_CHANGES_DETECTED_IN_OTHER = 'SIGNIFICANT_CHANGES_DETECTED_IN_OTHER',
    SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS = 'SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS',
    SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS_AND_SYNC = 'SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS_AND_SYNC',
    SUSPENDED = 'SUSPENDED',
    SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD = 'SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD',
    EXPIRED_AND_SUSPENDED = 'EXPIRED_AND_SUSPENDED',
    EXPIRED = 'EXPIRED',
    REJECTED = 'REJECTED',
    REJECTED_PP = 'REJECTED_PP'
}

export const ACTIVE_INTEGRATION_STATES = [
    IntegrationState.SYNCED,
    IntegrationState.EXPIRED,
    IntegrationState.SUSPENDED,
    IntegrationState.EXPIRED_AND_SUSPENDED,
    IntegrationState.REJECTED_PP,
    IntegrationState.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_OTHER,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS_AND_SYNC
];

export const INTEGRATION_STATES_WITH_DISABLED_SYNC = [
    IntegrationState.SUSPENDED,
    IntegrationState.EXPIRED_AND_SUSPENDED,
    IntegrationState.EXPIRED,
    IntegrationState.REJECTED_PP
];

export const INTEGRATION_STATES_WITH_DISABLED_IMPORT_SYNC = [
    IntegrationState.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_OTHER
];

export const INTEGRATIONS_STATES_WITH_ENABLED_EXPORT_SYNC = [
    IntegrationState.SYNCED,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_OTHER,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS,
    IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS_AND_SYNC,
    IntegrationState.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD
];

export interface IntegrationStateMetadata {
    title: string;
    cssClass: string;
    icon: string;
}

export const IntegrationStateMetadataMap = new Map<IntegrationState, IntegrationStateMetadata>([
    [
        IntegrationState.DEFAULT,
        {
            title: 'Default',
            cssClass: '',
            icon: ''
        }
    ],
    [
        IntegrationState.ORIGINAL,
        {
            title: 'Original',
            cssClass: '',
            icon: ''
        }
    ],
    [
        IntegrationState.DRAFT,
        {
            title: 'Draft',
            cssClass: '',
            icon: ''
        }
    ],
    [
        IntegrationState.SYNCED,
        {
            title: 'Synced',
            cssClass: 'smi-active',
            icon: 'check_circle'
        }
    ],
    [
        IntegrationState.PENDING,
        {
            title: 'Pending',
            cssClass: 'smi-invited',
            icon: 'schedule'
        }
    ],
    [
        IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT,
        {
            title: 'Changes Pending Approval',
            cssClass: 'smi-inactive',
            icon: 'error'
        }
    ],
    [
        IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_OTHER,
        {
            title: 'Data Verification',
            cssClass: 'smi-inactive',
            icon: ''
        }
    ],
    [
        IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS,
        {
            title: 'Data Verification',
            cssClass: 'smi-inactive',
            icon: ''
        }
    ],
    [
        IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_ACCESS_AND_SYNC,
        {
            title: 'Data Verification',
            cssClass: 'smi-inactive',
            icon: ''
        }
    ],
    [
        IntegrationState.SUSPENDED,
        {
            title: 'Suspended',
            cssClass: 'smi-inactive',
            icon: 'sync_disabled'
        }
    ],
    [
        IntegrationState.SUSPENDED_DUE_SCHOOL_YEAR_ROLL_OVER_PERIOD,
        {
            title: 'School Year Rollover Period',
            cssClass: 'smi-inactive',
            icon: 'warning'
        }
    ],
    [
        IntegrationState.EXPIRED_AND_SUSPENDED,
        {
            title: 'Suspended',
            cssClass: 'smi-inactive',
            icon: 'sync_disabled'
        }
    ],
    [
        IntegrationState.EXPIRED,
        {
            title: 'Expired',
            cssClass: 'smi-error',
            icon: 'sync_disabled'
        }
    ],
    [
        IntegrationState.REJECTED,
        {
            title: 'Rejected',
            cssClass: '',
            icon: ''
        }
    ],
    [
        IntegrationState.REJECTED_PP,
        {
            title: 'Rejected Privacy Policy',
            cssClass: 'smi-error',
            icon: ''
        }
    ]
]);
